import { mediaQueryLarge, requestIdleCallback, startViewTransition } from '@theme/utilities';
import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a pagniated results list
 */
export default class ResultsList extends PaginatedList {
  constructor() {
    super()
   this.sidebarToogle = this.querySelector('.toogle-sidebar-button button');
   this.sidebar = this.querySelector('.facets-block-wrapper');

  }
  connectedCallback() {
    super.connectedCallback();

    mediaQueryLarge.addEventListener('change', this.#handleMediaQueryChange);
    this.setAttribute('initialized', '');
    // this.customFilterOpen()


    this.showSidebar = false;
    if (localStorage.getItem('sidebarActive') === null) {
      localStorage.setItem('sidebarActive', 'false');
    }

    const sidebarState = localStorage.getItem('sidebarActive') === 'true';
    if (this.sidebarToogle) {
      this.setSidebarState(sidebarState);
    } else {
      localStorage.setItem('sidebarActive', 'false');
    }

    if (this.sidebarToogle) {
      this.sidebarToogle.addEventListener('click', () =>{
        this.toggleSidebar()
      }
      );
    }
  }

  disconnectedCallback() {
    mediaQueryLarge.removeEventListener('change', this.#handleMediaQueryChange);
  }

  /**
   * Updates the layout.
   *
   * @param {Event} event
   */
  updateLayout({ target }) {
    if (!(target instanceof HTMLInputElement)) return;

    this.#animateLayoutChange(target.value);
  }

  /**
   * Sets the layout.
   *
   * @param {string} value
   */
  #animateLayoutChange = async (value) => {
    const { grid } = this.refs;

    if (!grid) return;

    await startViewTransition(() => this.#setLayout(value), ['product-grid']);

    requestIdleCallback(() => {
      const viewport = mediaQueryLarge.matches ? 'desktop' : 'mobile';
      sessionStorage.setItem(`product-grid-view-${viewport}`, value);
    });
  };

  /**
   * Animates the layout change.
   *
   * @param {string} value
   */
  #setLayout(value) {
    const { grid } = this.refs;
    if (!grid) return;
    grid.setAttribute('product-grid-view', value);
  }

  /**
   * Handles the media query change event.
   *
   * @param {MediaQueryListEvent} event
   */
  #handleMediaQueryChange = (event) => {
    const targetElement = event.matches
      ? this.querySelector('[data-grid-layout="desktop-default-option"]')
      : this.querySelector('[data-grid-layout="mobile-option"]');

    if (!(targetElement instanceof HTMLInputElement)) return;

    targetElement.checked = true;
    this.#setLayout('default');
  };

  toggleSidebar() {
    let isActive = localStorage.getItem('sidebarActive') === 'true';
    isActive = !isActive;
    // Save back to localStorage
    localStorage.setItem('sidebarActive', isActive);
    this.setSidebarState(isActive) 
    // this.toggleGridColumns();
  }

  setSidebarState(isActive) {
    const mainContent = this.closest('main#MainContent');
    const facetsHederTitle = this.querySelector('.facets--filters-title'); 
    if (isActive) {
      this.sidebar.classList.remove('hidden');
      facetsHederTitle.style.display = 'block';
      this.sidebarToogle.classList.add('active');
      mainContent.classList.add('active-sidebar')
    } else {
      this.sidebar.classList.add('hidden');
      facetsHederTitle.style.display = 'none';
      this.sidebarToogle.classList.remove('active');
      mainContent.classList.remove('active-sidebar')
    }
  }

}

if (!customElements.get('results-list')) {
  customElements.define('results-list', ResultsList);
}
